import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setIsLoaded(true);
  }, []);
const slides = [
  {
    id: 1,
    title: 'ÇELİK TİCARET',
    subtitle: 'Kaliteyi ve Uygun Fiyatı Bir Arada Sunuyoruz!',
    cta: 'Şimdi Keşfet',
    image:
      '/logo.png',
      onClick: () => handleScroll('targetSection'),
  },
  {
    id: 2,
    title: 'Yeni Sezon Ürünleri',
    subtitle: 'Özel koleksiyonumuzu keşfedin',
    cta: 'Alışverişe Başla',
    image:
      '/slider1.jpg',
      onClick: () => navigate('/products/season'),
  },
  {
    id: 3,
    title: 'Uygulamamız Çıktı',
    subtitle: 'Mobil uygulamamızla alışveriş deneyimini bir adım ileri taşıyın! Hemen indir.',
    cta: 'İndir',
    image:
      '/slider2.jpg',
      onClick: () => navigate('/products'),
  },
];
  const handleScroll = (targetId) => {
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 8000 }}
        loop
        className="h-[500px] sm:h-[700px]"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="relative h-full w-full">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="absolute inset-0 bg-gray-dark/40" />
              </div>

              <div className="container-custom relative h-full flex flex-col justify-center items-start">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={isLoaded ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="max-w-lg text-white"
                >
                  <h1 className="text-4xl md:text-5xl font-bold mb-4">
                    {slide.title}
                  </h1>
                  <p className="text-lg md:text-xl mb-6">{slide.subtitle}</p>
                  <button
                    onClick={slide.onClick}
                    className="inline-block bg-primary text-white px-8 py-3 rounded-md hover:bg-primary-dark transition-colors"
                  >
                    {slide.cta}
                  </button>
                </motion.div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroSection;
